import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  Input,
} from "reactstrap";

import "./ModalResendEmail.css";
import { useContext, useRef, useState } from "react";
import InputStandard from "../Inputs/InputStandard";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { getQueryParam } from "../../utils/getQueryOaram";
import { useLocation } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { AuthContext } from "../../context/AuthContext";
import { UserTypeContext } from "../../context/UserTypeContext";
import { useToast } from "../../context/ToastContext";
import { ContactContext } from "../../context/ContactContext";

interface ModalComponentProps {
  openModal: any;
  closeModal: () => void;
}

const ModalResendEmail = (props: ModalComponentProps) => {
  const { openModal, closeModal } = props;
  const {resendEmail} = useContext(DocumentTypeContext);
  const showToast = useToast();
  const emailList = openModal?.row?.emailsSig || [];

  const [selectedEmails, setSelectedEmails] = useState<string[]>([]);


  const cleanFileds = () => {
    setSelectedEmails([]);
    closeModal();
  };
  const handleEmailSelection = (email: string) => {
    setSelectedEmails((prevSelected) =>
      prevSelected.includes(email)
        ? prevSelected.filter((e) => e !== email)
        : [...prevSelected, email]
    );
  };

  const resendEmailAction = async () => { 
    if (selectedEmails.length === 0) {
      showToast("info", "Selecione pelo menos um e-mail");
      return;
    } else {
      await resendEmail(openModal.row.id, selectedEmails);
      cleanFileds();
    }
  }

  return (
    <div>
      <Modal
        isOpen={openModal.open}
        toggle={closeModal}
        className="modal-content"
        style={{
          maxWidth: "600px",
          width: "90%",
          borderRadius: "10px",
        }}
      >
        {/* Título */}
        <div
          className="text-center"
          style={{
            color: "#222222",
            fontSize: "22px",
            fontWeight: "bold",
            marginBottom: "15px",
            marginTop: "15px",
          }}
        >
          Reenviar E-mail
        </div>

        {/* Corpo do Modal */}
        <ModalBody>
          {/* Lista de Emails */}
          <div style={{ marginBottom: "15px"}}>
            <strong style={{marginBottom: "15px" }}>Selecione os e-mails:</strong>
            {emailList.length > 0 ? (
              emailList.map((email: string, index: number) => (
                <div key={index}  className="form-check mt-2">
                  <Input
                    type="checkbox"
                    checked={selectedEmails.includes(email)}
                    onChange={() => handleEmailSelection(email)}
                  />
                  <label className="form-check-label" style={{ marginLeft: "8px" }}>
                    {email}
                  </label>
                </div>
              ))
            ) : (
              <p style={{ color: "gray", fontSize: "14px" }}>Nenhum e-mail disponível</p>
            )}
          </div>
        </ModalBody>

        {/* Botões de Ação */}
        <ModalFooter className="d-flex justify-content-center">
          <Row style={{ width: "100%" }}>
            <Col xs="6">
              <Button
                className="button-login"
                onClick={() => resendEmailAction()}
                block
              >
                Enviar
              </Button>
            </Col>
            <Col xs="6">
              <Button color="secondary" onClick={closeModal} block>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalResendEmail;
